import { useContext } from 'react'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { Input } from 'alurkerja-ui'
import { Controller } from 'react-hook-form'

export default function NominalUangSaku() {
  const { setValue, control } = useContext<CustomComponentContextType>(CustomComponentContext)

  const classNamesLabel = "after:content-['*'] after:text-red-400 after:text-sm font-medium"

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 space-x-2">
        <div>
          <label htmlFor="nominal_uang_saku" className={classNamesLabel}>
            Nominal Uang Saku
          </label>
          <Controller
            name={'nominal_uang_saku'}
            control={control}
            render={({ fieldState }) => {
              return (
                <>
                  <Input
                    id="nominal_uang_saku"
                    type="number"
                    min={0}
                    onChange={e => {
                      setValue('nominal_uang_saku', parseInt(e.target.value))
                    }}
                  />
                  {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
                </>
              )
            }}
          ></Controller>
        </div>
      </div>
    </div>
  )
}
